angular.module('CarsSaraBo').controller('TermAndConditionsController', [
    '$scope', '$rootScope', '$routeParams', '$location', 'ContractService',  'DataService', '$q',
    'SessionService', 'CompanyService', 'LoadingWheelService', 'NotificationService', 'ModalService',
    'LegalDocumentService', '$translate','ContractStatesService',
    function ($scope, $rootScope, $routeParams, $location, contractService, dataService, $q,
              sessionService, companyService, loadingWheelService, notificationService, modalService,
              legalDocumentService, $translate,statesService) {

        var PERM_LEGAL_DOCUMENT_EDIT = 'PERM_LEGAL_DOCUMENT_EDIT';
        var PERM_LEGAL_DOCUMENT_UPLOAD = 'PERM_LEGAL_DOCUMENT_UPLOAD';

        function initialize() {
            $scope.role =  sessionService.getUserSession().userType;
            $scope.validations = {};
            $scope.file = [];
            $scope.company = {};
            $scope.term = {};
            $scope.editableContract = isEditableContract();
            $scope.buttonAcceptTerm = false;
            $scope.buttonInitDisputeTerm = false;
            $scope.buttonInvalidateTerm = false;
            $scope.disputedDocumentModal = false;
            $scope.daysText;
            getLegalDocument();
        }

        function getLegalDocument(){
            loadingWheelService.show();
            $scope.term = null;
            var deferred = $q.defer();

            legalDocumentService.get({companyOid: $routeParams.companyOid, contractOid: $routeParams.oid, legalDocumentOid:$routeParams.legalDocumentOid})
                .$promise
                .then(function(response){
                    deferred.resolve();
                    $scope.term = response;
                    enableElementsByState();
                    loadingWheelService.hide();
                }, function(error){
                    deferred.reject();
                    $scope.term = null;
                    loadingWheelService.hide();
                });
        }

        function isEditableContract() {
            var canCreate = $scope.isNew && sessionService.loggedUserAllowed('PERM_CONTRACT_CREATE');
            var canEdit = !$scope.isNew && sessionService.loggedUserAllowed('PERM_CONTRACT_EDIT');

            return canCreate || canEdit;
        }

        $scope.updateValidation = function(field){
            if ($scope.errorField != undefined && $scope.errorField[field]) {
                $scope.errorField[field] = null;
            }
        };

        $scope.downloadDocument = function(){
            return "/cars-sara-v2/rest/company/" + $routeParams["companyOid"] + "/contract/" + $routeParams["oid"] + "/legalDocument/" + $routeParams["legalDocumentOid"] + "/resource";
        }

        $scope.goToDetailContract = function(){
            $location.path("/company/" +  $routeParams.companyOid + "/contract/" + $routeParams["oid"])
        }

        $scope.acceptDocument = function(){
            updateLegalDocumentState(statesService.ACCEPTED());
        }

        $scope.invalidateDocument = function(){
            updateLegalDocumentState(statesService.INVALIDATED());
        }

        $scope.initClaim = function(){
            updateLegalDocumentState(statesService.DISPUTED());
            $scope.showDisputedDocumentModal(true);
        }

        function updateLegalDocumentState(state){
            loadingWheelService.show();
            var deferred = $q.defer();

            legalDocumentService.update({companyOid: $routeParams.companyOid, contractOid:$routeParams["oid"], legalDocumentOid:$scope.term.oid}, {modifiedBy:sessionService.getUserLogged().username, state: state})
                .$promise.then(
                function(response){
                    deferred.resolve();
                    loadingWheelService.hide();
                    getLegalDocument();

                    if(statesService.isACCEPTED(state)){
                        notificationService.notifySuccessByCode('contract.terms.toast.message.accepted', null,10000);
                    }},
                function(error){
                    deferred.reject();
                    loadingWheelService.hide();
                });
        }

        $scope.showDisputedDocumentModal = function(val){
            $scope.disputedDocumentModal = val;
        }

        function isRoleRentadora(){
            return $scope.role === 'COMPANY';
        }

        $scope.hasPermissionAcceptTerm = function(){
            return $scope.buttonAcceptTerm && sessionService.loggedUserAllowed(PERM_LEGAL_DOCUMENT_EDIT);
        }

        $scope.hasPermissionDisputeTerm = function(){
            return $scope.buttonInitDisputeTerm && sessionService.loggedUserAllowed(PERM_LEGAL_DOCUMENT_EDIT);
        }

        $scope.hasPermissionInvalidateTerm = function(){
            return $scope.buttonInvalidateTerm && sessionService.loggedUserAllowed(PERM_LEGAL_DOCUMENT_UPLOAD);
        }

        function isRoleDespegar(){
            return $scope.role === 'DESPEGAR';
        }

        $scope.getIconColorMessageByState = function(term){
            return statesService.getIconColorMessageByState(term);
        }

        $scope.getKeyTextStateByUser = function(term){
            var keyText = isRoleRentadora()? 'contract.terms.company.message.state.detail.' + term.state: 'contract.terms.despegar.message.state.detail.' + term.state;

            if(term.state && statesService.isPENDING(term.state) && isRoleRentadora()){
                var days = term.daysPassedSinceLastModification;
                $scope.daysText = (15 - days) + ' ' + $translate.instant((days == 14)? keyText + '_day': keyText + '_days');
            }

            return keyText;
        }

        $scope.getTextColorMessageByState = function(term){
            return statesService.getTextColorMessageByState(term);
        }

        $scope.getIconMessageByState = function(term){
            return statesService.getIconMessageByState(term);
        }

        $scope.getColorMessageByState = function(term){
            return statesService.getColorMessageByState(term);
        }

        function enableElementsByState(){
            //this method enable or disable elements html according term's state
            $scope.buttonAcceptTerm = false;
            $scope.buttonInitDisputeTerm = false;
            $scope.buttonInvalidateTerm = false;

            if($scope.term){
                switch ($scope.term.state) {
                    case statesService.PENDING():
                        if(isRoleRentadora()) {
                            $scope.buttonAcceptTerm = true;
                            $scope.buttonInitDisputeTerm = true;

                        } else if(isRoleDespegar()){
                            $scope.buttonInvalidateTerm = true;
                        }
                        break;
                    case statesService.DISPUTED():
                        if(isRoleRentadora()) {
                            $scope.buttonAcceptTerm = true;

                        }else if(isRoleDespegar()){
                            $scope.buttonInvalidateTerm = true;
                        }
                        break;
                }
            }
        }

        initialize();
    }]);



//////////////////
// WEBPACK FOOTER
// ./public/app/contract/viewTermAndConditions_controller.js
// module id = 924
// module chunks = 3